import React from 'react'
import PropTypes from 'prop-types'

import DisclosureModal from 'multi-vertical/rate-table/components/disclosure-modal'
import disclaimers from 'personal-loan/rate-table/lender/disclaimers'
import CtaButton from 'components/cta-button'
import { PartnerLogo } from 'components/partner-logo'
import { fireGtmEvent } from 'utils/gtm'

import styles from './styles.module.scss'
import { scrollToIframeTop } from '../../../utils'

const onCtaClicked = (lenderName, widgetContext) => () => {
  const lender = { lender: lenderName }

  fireGtmEvent('ctaClick', Object.assign(lender, widgetContext))
}
const LenderTile = ({
  lender: { rateSlug, name, slug, minFixedRate, maxFixedRate, minLoanTerm, maxLoanTerm },
  ctaUrl,
  widgetContext,
}) => {
  return (
    <div data-test-id={`rateTableTile_${rateSlug}`} className={`${styles.lenderSection} mt-8`}>
      <div className={styles.logo}>
        <PartnerLogo partner={slug} />
        {!!disclaimers[slug] && (
          <DisclosureModal
            title="Disclaimer"
            name={name}
            onOpenModalHandler={() => scrollToIframeTop()}
          >
            {disclaimers[slug]}
          </DisclosureModal>
        )}
      </div>
      <div className={styles.rate}>
        <p className={`${styles.subtitle} disclaimer mb-0 mb-sm-8`}>Fixed APR from</p>
        <p className={`${styles.number} semiBold`}>
          {minFixedRate}% - {maxFixedRate}%
        </p>
      </div>
      <div className={styles.term}>
        <p className={`${styles.subtitle} disclaimer mb-0 mb-sm-8`}>Loan terms</p>
        <p className={`${styles.number} semiBold`}>
          {minLoanTerm} - {maxLoanTerm} years
        </p>
      </div>
      <div className={styles.ctaSection}>
        <CtaButton
          href={ctaUrl}
          target="_blank"
          onClick={onCtaClicked(name, widgetContext)}
          size="small"
        >
          Check Rates
        </CtaButton>
        <p className={`${styles.texts} disclaimer mt-8 align-center hidden-xs`}>
          on Credible's website
        </p>
      </div>
    </div>
  )
}
LenderTile.propTypes = {
  lender: PropTypes.object,
  ctaUrl: PropTypes.string,
  widgetContext: PropTypes.object,
}

export { LenderTile, onCtaClicked }

export default LenderTile
